import { useState } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TokenAccordionSummary from "./TokenAccordionSummary";
import TokenAccordionDetails from "./TokenAccordionDetails";
import { buildDateString } from "../../support/utils";

const TokenAccordion = ({ token, filters }) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Accordion
      disableGutters={true}
      square={true}
      elevation={token.contractState === "PENDING" ? 1 : 5}
      expanded={expanded}
      slotProps={{ transition: { timeout: 200 } }}
    >
      <AccordionSummary
        sx={{ pointerEvents: "none", width: "100%" }}
        expandIcon={
          <Button
            sx={{
              pointerEvents: "auto",
              display: { xs: "contents", sm: "inline-flex" },
            }}
            onClick={() => setExpanded((prev) => !prev)}
          >
            <ExpandMoreIcon />
          </Button>
        }
      >
        <TokenAccordionSummary token={token} filters={filters} />
      </AccordionSummary>
      <AccordionDetails sx={{ display: "inline-block", width: "100%" }}>
        <TokenAccordionDetails token={token} open={expanded} />
      </AccordionDetails>
    </Accordion>
  );
};

export default TokenAccordion;
